import ServiceBase from "./apiServiceBase";

const { REACT_APP_PREPAYMENT_SERVER_URL } = process.env;

class PrepaymentApiService extends ServiceBase {
  async createPrepayment(request) {
    const response = await this.post(`${REACT_APP_PREPAYMENT_SERVER_URL}/prepayments`, request);
    return response;
  }
}

export default new PrepaymentApiService();
